import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { overrides } from '@cld/button';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';

const { ButtonLink } = overrides.mediaLibraryWidgetDemoOverrides;

export interface ViewProps {
  tab: string;
  text: string;
  img: string;
  link: string;
}

const Root = styled.div`
  display: flex;
  padding: calc(${globalTheme.spacing.md} * 3) 0;

  > * {
    width: 50%;
  }
`;

const Image = styled.img`
  box-sizing: border-box;
  padding: ${globalTheme.spacing.xl};
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 ${globalTheme.spacing.lg} 0 calc(${globalTheme.spacing.lg} * 3);
`;

const Paragraph = styled.p`
  ${website.brandText.lg.regular};
`;

export const View: FC<ViewProps> = ({ tab, img, text, link }) => {
  const analytics = useAnalytics();

  return (
    <Root id={`${tab}-view`} aria-labelledby={tab} data-test={`tabs-section-${tab}-view`}>
      <Image src={img} alt={img} />
      <TextWrapper>
        <div>
          <Paragraph>{text}</Paragraph>
          <ButtonLink
            shape="pill"
            variant="secondary"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analytics('learn more', `clicked on learn more to learn more about ${tab} doc`)}
            data-test="tabs-section-learn-more-button"
          >
            <FormattedMessage {...messages['landing.tabsSection.learnMore']} />
          </ButtonLink>
        </div>
      </TextWrapper>
    </Root>
  );
};
